// extracted by mini-css-extract-plugin
module.exports = {"form":"ForgotPasswordVerifyPage_form__3HO3l"};